export interface GlobalStateBag {
  [key: string]: unknown;
}

const globalScope = globalThis as unknown as { globalState?: GlobalStateBag };
globalScope.globalState ??= {};

export function globalState(): GlobalStateBag {
  globalScope.globalState ??= {};
  return globalScope.globalState;
}
